import { useQuery } from '@tanstack/react-query';
import { wordpressService, WordPressPost, WordPressCategory, WordPressAuthor } from '@/services/wordpress';

export const useWordPressPosts = (params: {
  page?: number;
  per_page?: number;
  search?: string;
  categories?: string;
  'docs-category'?: string;
  orderby?: string;
  order?: 'asc' | 'desc';
} = {}) => {
  return useQuery({
    queryKey: ['wordpress-posts', params],
    queryFn: () => wordpressService.fetchPosts(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useWordPressPost = (slug: string) => {
  return useQuery({
    queryKey: ['wordpress-post', slug],
    queryFn: () => wordpressService.fetchPost(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useWordPressCategories = () => {
  return useQuery({
    queryKey: ['wordpress-categories'],
    queryFn: () => wordpressService.fetchCategories(),
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};

export const useWordPressAuthor = (id: number) => {
  return useQuery({
    queryKey: ['wordpress-author', id],
    queryFn: () => wordpressService.fetchAuthor(id),
    enabled: !!id,
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export const useWordPressFeaturedImage = (post: WordPressPost | undefined) => {
  return useQuery({
    queryKey: ['wordpress-featured-image', post?.featured_media],
    queryFn: () => post ? wordpressService.getFeaturedImageUrl(post) : null,
    enabled: !!(post?.featured_media),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export const useWordPressComments = (postId: number) => {
  return useQuery({
    queryKey: ['wordpress-comments', postId],
    queryFn: () => wordpressService.fetchComments(postId),
    enabled: !!postId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};